import { request } from "../utils/request.js"

export const fundPayOrder_exportForManage = (pojo, args) => request({
    url: 'fundPayOrder/exportForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const fundPayOrder_findPageForManage = (pojo, args) => request({
    url: 'fundPayOrder/findPageForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const fundPayOrder_findPageListForManage = (pojo, args) => request({
    url: 'fundPayOrder/findPageListForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const fundPayOrder_findPageForCurrentUser = (pojo, args) => request({
    url: 'fundPayOrder/findPageForCurrentUser',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const fundPayOrder_findPageListForCurrentUser = (pojo, args) => request({
    url: 'fundPayOrder/findPageListForCurrentUser',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})


export const fundPayOrder_saveIntoDraft = (pojo, args) => request({
    url: 'fundPayOrder/saveIntoDraft',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const fundPayOrder_saveIntoDraftAndSubmit = (pojo, args) => request({
    url: 'fundPayOrder/saveIntoDraftAndSubmit',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const fundPayOrder_update = (pojo, args) => request({
    url: 'fundPayOrder/update',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const fundPayOrder_updateAndSubmit = (pojo, args) => request({
    url: 'fundPayOrder/updateAndSubmit',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const fundPayOrder_submitById = (id, args) => request({
    url: 'fundPayOrder/submitById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const fundPayOrder_deleteById = (id, args) => request({
    url: 'fundPayOrder/deleteById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const fundPayOrder_approval = (pojo, args) => request({
    url: 'fundPayOrder/approval',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const fundPayOrder_findById = (id, args) => request({
    url: 'fundPayOrder/findById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})

export const fundPayOrder_findVoById = (id, args) => request({
    url: 'fundPayOrder/findVoById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})


// WEBPACK FOOTER //
// ./src/api/fundPayOrder.js